// Add your custom JS here.
(function ($) {
  $(document).ready(function () {
    // initialise css vars
    $("body").css("--navbar-height", $("#main-nav").outerHeight() + "px");
    $("body").css("--topbar-height", $("#topbar").outerHeight() + "px");

    // TODO: animate highlighted text

    // add the dot to the dom
    //$('.navbar-nav').append('<div class="dot">&#8226;</div>');

    // set initial dot position
    // const   selector = '.navbar-nav > .current-menu-item',
    //         initialXOffset = $(selector).position().left,
    //         initialWidth = $(selector).width();

    // $('.dot').css('left', initialXOffset).css('width', initialWidth).css('opacity', 1);

    // changes dot position when hovering menu item
    // $('.navbar-nav > li > a').on( "mouseenter", function() {
    //     const   xOffset = $(this).position().left,
    //             width = $(this).width();

    //     $('.dot').css('left', xOffset).css('width', width);
    // });

    // resets the dot position
    // $('.navbar-nav > li > a').on( "mouseleave", function() {
    //     $('.dot').css('left', initialXOffset).css('width', initialWidth);
    // });

    // handle fixed menu
    $(window).scroll(function () {
      if ($(window).scrollTop() > 400 && 992 < $(window).width()) {
        $("#main-nav").addClass("fixed-top");
        $("body").css("--navbar-height", $("#main-nav").outerHeight() + "px");

        // add padding top to show content behind navbar
        $("body").css("padding-top", $("body").css("--navbar-height"));
      } else {
        $("#main-nav").removeClass("fixed-top");
        $("body").css("--navbar-height", $("#main-nav").outerHeight() + "px");

        // remove padding top from body
        $("body").css("padding-top", "0");
      }
    });

    // display mega menu
    $(".mega-menu").appendTo(".has-mega-menu-services");

    $(".has-mega-menu-services")
    .on("mouseenter", function() {
        if (! $(".mega-menu").hasClass("show")) {
          $(".mega-menu").addClass("show");
        }
    })
    .on("mouseleave", function() {
      if ($(".mega-menu").hasClass("show")) {
        $(".mega-menu").removeClass("show");
      }
    })
    .on("click", function() {
      if ($(".mega-menu").hasClass("show")) {
        $(".mega-menu").removeClass("show");
      } else {
        $(".mega-menu").addClass("show");
      }
    });

    // mobile menu
    $(".navbar-toggler").on("click", function () {
      $(this).toggleClass("open");
      $("body").toggleClass("overflow-hidden");
      $("#container-mobile-menu").toggleClass("open");
    });

    // hide menu when clicking on an item
    $("#mobile-menu li:not(.has-mega-menu-services) a").on(
      "click",
      function () {
        $("#container-mobile-menu").toggleClass("open");
      }
    );

    // floating button
    $(".container-floating").on("click", function (event) {
      event.preventDefault();

      $(this).toggleClass("show");

      $(".btn-float").on("click", function (event) {
        event.stopPropagation();
      });
    });

    // wpforms : conditional logic for Submit button
    $('#wpforms-form-1497 input[name="wpforms[fields][7]"]').on('change', function() {
        var selectedVal = $(this).val();

        if(selectedVal == "Créer/maintenir un site internet/application") {
            $("#wpforms-form-1497 .wpforms-submit").addClass("show-submit");
        } else {
            $("#wpforms-form-1497 .wpforms-submit").removeClass("show-submit");
        }
    });
  });
})(jQuery);

// swiper carousel for featured portfolio
const swiper_portfolio = new Swiper(".swiper-portfolio", {
  // Optional parameters
  effect: "cards",
  grabCursor: true,
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

// swiper carousel for testimonials
const swiper_testimonial = new Swiper(".swiper-testimonial", {
  // Optional parameters
  slidesPerView: 1,
  spaceBetween: 10,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 480px
    768: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});
